import script from "./pp-s10-winnings.vue?vue&type=script&lang=ts&setup=true"
export * from "./pp-s10-winnings.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__